import type { IMessagesWithSubscriptionModel } from '../../../../../repositories/billing-tariffs/entities/PopupMessages/MessagesWithSubscriptionModel';
import { ERestrictionType, IRestriction } from '../../../../../reducers/v2/paidPublication/types';

export function getRestriction(message: IMessagesWithSubscriptionModel | undefined): IRestriction {
  return {
    isAllowed: !message,
    restrictionType: message?.subAgentLimitExceed ? ERestrictionType.SubAgentLimitExceeded : undefined,
  };
}
